import { useCallback, useRef } from 'react';

import type { Transaction } from 'prosemirror-state';

import { ProsemirrorInsertTextManager } from '../effects/ProsemirrorInsertTextManager';

export const useTranscriptionToEditorText = () => {
	const prosemirrorInsertTextManager = useRef<ProsemirrorInsertTextManager>(
		new ProsemirrorInsertTextManager(),
	);

	const handleTranscriptUpdate = useCallback((transcript: string, tr: Transaction) => {
		return prosemirrorInsertTextManager.current.insertText(transcript, tr);
	}, []);

	const rejectTranscriptedText = useCallback((tr: Transaction) => {
		return prosemirrorInsertTextManager.current.rejectTranscriptedText(tr);
	}, []);

	const disposeTranscriptedText = useCallback((): void => {
		prosemirrorInsertTextManager.current.disposeTranscriptedText();
	}, []);

	return { handleTranscriptUpdate, rejectTranscriptedText, disposeTranscriptedText };
};
